export var Command;
(function (Command) {
    Command["INIT"] = "init";
    Command["GET"] = "get";
    Command["GET_ALL"] = "getAll";
    Command["DELETE"] = "delete";
    Command["INSERT"] = "set";
    Command["UPDATE"] = "update";
    Command["UPDATE_MUTIL_TABLE_DATA"] = "updateMultiTableData";
    Command["BEGIN_TRANSACTION"] = "beginTransaction";
    Command["COMMIT_TRANSACTION"] = "commitTransaction";
    Command["ROLLBACK_TRANSACTION"] = "rollbackTransaction";
})(Command || (Command = {}));
export var ClientQueryConditionType;
(function (ClientQueryConditionType) {
    ClientQueryConditionType[ClientQueryConditionType["IN"] = 0] = "IN";
    ClientQueryConditionType[ClientQueryConditionType["LOWER_BOUND"] = 1] = "LOWER_BOUND";
    ClientQueryConditionType[ClientQueryConditionType["UPPER_BOUND"] = 2] = "UPPER_BOUND";
    ClientQueryConditionType[ClientQueryConditionType["BOUND"] = 3] = "BOUND";
    ClientQueryConditionType[ClientQueryConditionType["ONLY"] = 4] = "ONLY";
    ClientQueryConditionType[ClientQueryConditionType["NOT_IN"] = 5] = "NOT_IN";
})(ClientQueryConditionType || (ClientQueryConditionType = {}));
export var IOrderType;
(function (IOrderType) {
    /**
     * 默认比较升序
     */
    IOrderType[IOrderType["INCREASE"] = 0] = "INCREASE";
    /**
     * 默认比较降序
     */
    IOrderType[IOrderType["DECREASE"] = 1] = "DECREASE";
    /**
     * 按文本比较升序
     */
    IOrderType[IOrderType["INCREASE_BY_TEXT"] = 2] = "INCREASE_BY_TEXT";
    /**
     * 按文本比较降序
     */
    IOrderType[IOrderType["DECREASE_BY_TEXT"] = 3] = "DECREASE_BY_TEXT";
})(IOrderType || (IOrderType = {}));
//# sourceMappingURL=client-msg.interface.js.map